export function loadStyles() {
  if (window.location.href.includes("/admin/")) {
    import("@/assets/css/admin.css");
  } else {
    // Load default styles
    import("@/assets/css/style.css");
  }
}
